// Copie FR/EN de GsPresence / GsFonctionIndisponible (precedent AccessGate, GsPreproductionBanner) :
// le MEME avis dans toutes les apps, sans une cle de catalogue par app. Zero t() dans @gs/ui.
//
// Les cles de `raisons` sont celles de `RAISONS_ABSENCE` (`@gs/utils`, primitive de presence).
// @gs/ui ne depend pas de @gs/utils : la parite est tenue par
// `tools/__tests__/presence-parite-des-raisons.test.ts`, qui rougit sur une raison sans texte.

export const GS_PRESENCE_COPY = {
  fr: {
    titre: (fonction: string) => `${fonction} — indisponible`,
    fonctionParDefaut: 'Cette fonction',
    raisons: {
      'sans-adresse': (application: string) => `L’adresse de ${application} n’est pas configurée.`,
      reseau: (application: string) => `${application} est injoignable.`,
      delai: (application: string) => `${application} ne répond pas à temps.`,
      serveur: (application: string) => `${application} est momentanément indisponible.`,
    },
    inconnue: (application: string) => `${application} ne répond pas.`,
    suite: 'Le reste de la page fonctionne normalement ; la fonction reviendra d’elle-même.',
  },
  en: {
    titre: (fonction: string) => `${fonction} — unavailable`,
    fonctionParDefaut: 'This feature',
    raisons: {
      'sans-adresse': (application: string) => `The address of ${application} is not configured.`,
      reseau: (application: string) => `${application} cannot be reached.`,
      delai: (application: string) => `${application} is not answering in time.`,
      serveur: (application: string) => `${application} is temporarily unavailable.`,
    },
    inconnue: (application: string) => `${application} is not answering.`,
    suite: 'The rest of the page works normally; the feature comes back on its own.',
  },
} as const;

/** Les raisons d absence qui ont un texte, dans les deux langues. */
export const GS_PRESENCE_RAISONS_TRADUITES = Object.keys(GS_PRESENCE_COPY.fr.raisons);
